import axios from "axios";
import React, { useEffect, useContext, useState } from "react";
import UserDataContext from "../../context/UserDataContext";
import { translate } from "../../translations";

function ServiceSettings() {
  const [recordData, setRecordData] = useState({
    fieldList: [],
    activatedFields: [],
    picklistValues: {},
  });
  const [error, setError] = useState(false);
  const token = localStorage.getItem("token");
  const project = localStorage.getItem("currentProjectID");
  const [success, setSuccess] = useState(false);
  const { userData } = useContext(UserDataContext);

  async function getData() {
    const fieldList = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/serviceFields/`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    const activatedFields = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/editServices/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setRecordData({
      fieldList: fieldList.data.serviceKeys,
      activatedFields: activatedFields.data["0"]
        ? activatedFields.data["0"].value.activatedFields
        : [],
    });
  }

  async function register(e) {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/settings/editServices/${project}`,
        recordData,
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 4000);
    } catch (err) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 5000);
    }
  }

  useEffect(() => {
    getData();
  }, [userData]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-center">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Leistungsobjekt konfigurieren
          </h3>
        </div>
      </div>
      <div className="bg-white overflow-hidden sm:rounded-lg flex justify-center my-5">
        <div className="container flex justify-start w-full">
          <div className="flex flex-col grow">
            <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
              <form onSubmit={register}>
                <div className="shadow overflow-hidden sm:rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6">
                    <div className="grid grid-cols-6 gap-6">
                      <div className="col-span-3">
                        <label className="block text-sm font-medium text-gray-700">
                          Bitte wähle aus welche Felder für Leistungen verfügbar
                          sein sollen
                        </label>
                        <select
                          id="kostenstellen"
                          multiple
                          onChange={(e) =>
                            setRecordData({
                              ...recordData,
                              activatedFields: Array.from(
                                e.target.selectedOptions,
                                (option) => option.value
                              ),
                            })
                          }
                          value={recordData.activatedFields}
                          className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                          {recordData.fieldList.map((serviceField) => (
                            <option value={serviceField}>
                              {translate(serviceField)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Speichern
                    </button>
                    {success && (
                      <div
                        className="flex rounded-md items-center bg-green-500 text-white text-sm font-bold px-4 py-3 my-5"
                        role="alert"
                      >
                        <svg
                          className="fill-current w-6 h-6 mr-3"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                        </svg>
                        <p>
                          <p>Speichern erfolgreich!</p>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServiceSettings;
